/* eslint-disable no-underscore-dangle */
import { createStore, compose, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import renderingInServer from '@shared/renderingInServer';
import actions from '@store/actions';
import setServerSideRenderedData from './actions/setServerSideRenderedData';
import initializePendoMiddleware from './pendoMiddleware';
import analyticsMiddleware from './analyticsMiddleware';
import {
  UIReducer,
  listingsReducer,
  buildingsReducer,
  currentUserReducer,
  shapesReducer,
  savedListingsReducer,
  loadedReducer,
  landlordsReducer,
  pageReducer,
  enumsReducer,
  savedSearchesReducer,
  savedBuildingsReducer,
  savedBuildingOwnersReducer,
  mapReducer,
  tourbookReducer,
} from './reducers';

export const reducers = combineReducers({
  // PLEASE PLEASE PLEASE KEEP THIS SORTED ALPHABETICALLY, this determines order in the dev tools
  buildings: buildingsReducer,
  enums: enumsReducer,
  currentUser: currentUserReducer,
  landlords: landlordsReducer,
  listings: listingsReducer,
  loadingStates: loadedReducer,
  map: mapReducer,
  page: pageReducer,
  savedBuildings: savedBuildingsReducer,
  savedBuildingOwners: savedBuildingOwnersReducer,
  savedListings: savedListingsReducer,
  savedSearches: savedSearchesReducer,
  shapes: shapesReducer,
  tourbooks: tourbookReducer,
  ui: UIReducer,
});

export default function configureStore(preloadedState, originalData, entity, enums) {
  const composeEnhancers = renderingInServer()
    ? compose
    : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  let initialState = preloadedState;

  if (entity) {
    const action = setServerSideRenderedData({ data: originalData, entity });
    initialState = reducers(initialState, action);
  }

  if (enums) {
    const enumAction = actions.setEnums(enums);
    initialState = reducers(initialState, enumAction);
  }

  return createStore(
    reducers,
    initialState,
    composeEnhancers(applyMiddleware(thunk, analyticsMiddleware, initializePendoMiddleware)),
  );
}
